export const FieldType = {
  InitiativeField: 'initiative_field',
  Section: 'section',
  TimePeriod: 'time_period',
} as const;

export type FieldType = (typeof FieldType)[keyof typeof FieldType];
